import { baseUrl } from "../../../../../utils";

const ModalData =
    [
        [{
            id: 1,
            name: "Webpage",
            target: "#tagWidgetModal",
            idd: "webpage_click_from_webpage",
            image: "webpage"
        },

        {
            id: 2,
            name: "Run Social Ads",
            target: "#socailAdsModal",
            idd: "social_ads_click_from_webpage",
            image: "run-social-ads"
        },

        {
            id: 3,
            name: "Email Campaign",
            target: "#emailCampaignModal",
            idd: "email_click_from_webpage",
            image: "email-campaign"
        },

        {
            id: 4,
            name: "Shoppable Galleries",
            target: "#shoppableModal",
            idd: "shoppable_click_from_webpage",
            image: "make-shoppable"
        }],
        [
            {
                id: 1,
                name: "Webpage",
                text: "<strong>Incorporate</strong> the Taggbox widget on specific web pages to showcase user-generated content to influence and engage your audience with social proof.",
                btnName: 'Try Now',
                videoURL: baseUrl(`explore-options/webpage-large.png`),
                labelledby: 'tagWidgetModalLabel',
                modelId: "tagWidgetModal",
                iframeID: 'TagBasedVideo',
                redirect: 'cookie',
                btnURL: `/widget/wall/index/`,
                link_type: 2,
                classUpdate: 'publish_web_page',
                reactRoute: 1,
                type: 'image'
            },

            {
                id: 2,
                name: "Run Social Ads",
                modelId: "socailAdsModal",
                iframeID: 'runSocialAds',
                btnName: 'Take Rights Now',
                videoURL: "771434260",
                btnURL: `/moderation/index/`,
                link_type: 2,
                text: 'Add UGC in your social ads to level-up engagement  clickthroughs. Get your UGC rights from original content creators to run social ad campaigns ethically.',
                labelledby: 'socailAdsModalLabel',
                redirect: 'same-page',
                type: 'vimeo'
            },

            {
                id: 3,
                name: "Email Campaign",
                modelId: "emailCampaignModal",
                iframeID: 'emailCampaignVideo',
                btnName: 'Try Now',
                videoURL: "771433320",
                btnURL: `/widget/wall/index/`,
                link_type: 2,
                text: "Amp up your email game with UGC powered by Taggbox! Display authenticity in your email campaigns and roll out customer-centric emails that inspire.",
                labelledby: 'emailCampaignScreensModalLabel',
                redirect: 'cookie',
                classUpdate: 'publish_email_campaign',
                reactRoute: 3,
                type: 'vimeo'
            },

            {
                id: 4,
                name: "Shoppable Galleries",
                modelId: "shoppableModal",
                iframeID: 'shoppableVideo',
                btnName: 'Try Tagshop',
                videoURL: "taggshop.mp4",
                btnURL: `https://tagshop.ai`,
                link_type: 1,
                text: 'Customize and tag your products to transform them into shoppable galleries. Capitalize on the users’ inspiration and boost conversion rates faster!.',
                labelledby: 'shoppableModalLabel',
                redirect: 'new-tab',
                type: 'video'
            }
        ],

    ];


export default ModalData